import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControlStatus } from '@angular/forms';

import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'z-validation',
  templateUrl: './validation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidationComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<boolean>();

  /**
   * control instance
   */
  @Input() control: AbstractControl;

  message$ = new BehaviorSubject<string[]>([]);

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(private translocoService: TranslocoService, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.control.statusChanges.pipe(takeUntil(this.destroy$)).subscribe((status: FormControlStatus) => {
      if (status === 'VALID' || status === 'PENDING' || status === 'DISABLED') {
        this.message$.next([]);
        return;
      }

      if (this.control.pristine) {
        return;
      }

      const errors: string[] = [];

      for (const error of Object.keys(this.control.errors)) {
        if (error === 'required') {
          errors.push(this.translate('core.components.form_status.errors.required'));
        }

        if (error === 'valueNotAllowed') {
          errors.push(this.translate('core.components.form_status.errors.value_not_allowed'));
        }

        if (error === 'min') {
          errors.push(this.translate('core.components.form_status.errors.min'));
        }

        if (error === 'max') {
          errors.push(this.translate('core.components.form_status.errors.max'));
        }

        if (error === 'minLength') {
          errors.push(this.translate('core.components.form_status.errors.min_length'));
        }

        if (error === 'maxLength') {
          errors.push(this.translate('core.components.form_status.errors.max_length'));
        }

        if (error === 'atLeastOne') {
          errors.push(this.translate('core.components.form_status.errors.at_least_one'));
        }

        if (error === 'fieldValueMismatch') {
          errors.push(this.translate('core.components.form_status.errors.field_value_mismatch'));
        }
      }

      this.message$.next(errors);
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  update() {
    this.changeDetectorRef.detectChanges();
  }
}
